<template>
  <iframe
    :src="calculatedSrc"
    :style="calculateStyle"
  >
  </iframe>
</template>

<script>

export default {
  name: 'IframeMap',
  props: {
    'loc': {
      type:Object,
      default: () => {
        return {
          latitude:25.0,
          longitude:121.0,
          zIndex:16
        }
      }
    },
    'height': {
      type:String,
      default: () => {
        return "200px;"
      }
    }
  },
  data: function () {
    return {
      //zIndex:16
    }
  },
  computed: {
    calculatedSrc () {
      // s99的地圖src有編碼過,地址內嵌了,改lat/long置換沒用
      //let tmpSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.4998226846487!2d{longitude}!3d{latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abde6fa9ef8d%3A0x798d39e9771c73f9!2zMTA0OTHlj7DljJfluILkuK3lsbHljYDpgbzlr6fooZc3MuiZnw!5e0!3m2!1szh-TW!2stw!4v1546934862331"
      // 確定這樣可用但沒有title mark
      let tmpSrc = window.location.protocol+"//maps.google.com.tw/maps?f=q&hl=zh-TW&geocode=&q={latitude},{longitude}({address})&z={zIndex}&output=embed&t="
      tmpSrc = tmpSrc.replace('{latitude}',this.loc.latitude)
      tmpSrc = tmpSrc.replace('{longitude}',this.loc.longitude)
      tmpSrc = tmpSrc.replace('{zIndex}',this.loc.zIndex?this.loc.zIndex:'16')
      tmpSrc = tmpSrc.replace('{address}',"地標")
      return tmpSrc
    },
    calculateStyle () {
      // width被組件外面控制只能是100%,由col值的grid system決定
      if (this.height) {
        return "height:"+this.height
      }
      return undefined
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
